module.exports = __webpack_public_path__ + "static/media/ksvpnLogo512.bf195aa5.png";